module.exports = __webpack_public_path__ + "img/app4.ff8e1400.jpg";